module.exports = __webpack_public_path__ + "static/img/icon_02.0a08d174.png";